import { builder } from '../editry/cms';
import { getCurrentLanguage } from './languageSwitcher';

export const getCurrentLocale = getCurrentLanguage;

export { builder };
export default builder;
